import { Controller } from 'stimulus'
import { BREAKPOINTS } from '../../_js/base/consts'

export default class HandoffController extends Controller {
  static targets = ['horizontalGuidelines']

  connect() {
    window.scroll_delay = 475
    window.localStorage.setItem('inspector_introduction_seen', true)

    this.pageLoaded = false
    window.addEventListener('load', () => {
      this.pageLoaded = true
      this.calcTargets()
    })
    window.addEventListener('resize', this.calcTargets.bind(this))
  }

  calcTargets() {
    this.horizontalGuidelinesTargets.forEach((target) => {
      HandoffController.calc(target)
    })
  }

  static calc(target) {
    const distance = target.offset().left;
    const lines = [target.querySelector('.inspect-line--left'), target.querySelector('.inspect-line--right')];

    lines.forEach((line) => {
      const pill = line.querySelector('.inspect-line__pill-value')
      pill.innerHTML = distance
      line.style.width = distance + 'px'
      line.classList.remove('is-hidden')
    })
  }

  displayIframe() {
    const iframeContainer = document.querySelector('.iframe-container')
    iframeContainer.classList.add('is-loaded');
  }


  static isElementAllInsideViewport(el) {
    const elementBounds = el.getBoundingClientRect()
    return (
      elementBounds.top + window.scroll_delay >= 0 &&
      elementBounds.left >= 0 &&
      elementBounds.bottom - window.scroll_delay <= (window.innerHeight || document.documentElement.clientHeight) &&
      elementBounds.right <= (window.innerWidth || document.documentElement.clientWidth)
    )
  }

  static isSafari() {
    const ua = navigator.userAgent.toLowerCase()
    if (ua.indexOf('safari') != -1) {
      if (ua.indexOf('chrome') == -1) {
        return true
      }
    }
    return false
  }
}
